// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast{
  display:grid;
  grid-template-areas:'icon title close' 'icon message close';
  grid-template-rows:min-content 1fr;
  grid-template-columns:min-content 1fr min-content;
  column-gap:0.5rem;
  width:25.75rem;
  max-width:100%;
  padding:0.75rem;
  color:#424242;
  background:#fff;
  border-left-style:solid;
  border-left-width:4px;
  border-radius:0.25rem;
  box-shadow:0 3px 12px rgb(0, 0, 0, 0.2);
}
.toast__icon{
    display:inline-flex;
    grid-area:icon;
    align-items:start;
  }
.toast__title{
    grid-area:title;
    margin-bottom:0.25rem;
    font-weight:700;
  }
.toast__message{
    grid-area:message;
    white-space:pre-line;
  }
.toast__close-container{
    grid-area:close;
  }
.toast__close-container .toast__close{
      width:1.5rem;
      height:1.5rem;
    }
.toast--info{
    border-left-color:#206dd2;
  }
.toast--info .toast__icon{
    color:#206dd2;
  }
.toast--success{
    border-left-color:#428629;
  }
.toast--success .toast__icon{
    color:#428629;
  }
.toast--warning{
    border-left-color:#db6b16;
  }
.toast--warning .toast__icon{
    color:#db6b16;
  }
.toast--error{
    border-left-color:#dd201d;
  }
.toast--error .toast__icon{
    color:#dd201d;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
